<template>
    <div class="furnitures-page">
        <h1 v-if="lang == 'fr'">Chaussettes protège-bois</h1>

        <div class="description" v-if="lang=='fr'">
          <img src="../assets/furnitures/sox0.png" class="main-sox"/>
          <p>
            Pour protéger vos têtes de club  dans de bonnes conditions et qualité, Amélie de Chassey a choisi de revenir aux valeurs classiques et d’antan. Utiliser de la laine de qualité  dans des mains bienveillantes et expérimentées de grandes tricoteuses (de tous âges et horizons…). Quelques-unes taillées sur le volet, réaliseront les "chaussettes" dont vous rêvez, couleurs, pompoms, filets, chiffres, points... Rien n’a de secret pour elles .
          </p>
          <p>
            En 10 jours votre série de trois couvre-bois ou autres pour un montant de 100 euros  vous sera envoyée ou 50 euros pour un seul à votre image (frais de port offert).
          </p>

          <div class="sox-gallery">
              <img src="../assets/furnitures/sox1.jpg" />
              <img src="../assets/furnitures/sox2.jpg" />
              <img src="../assets/furnitures/sox3.jpg" />
              <img src="../assets/furnitures/sox4.png" />
              <img src="../assets/furnitures/sox5.png" />
          </div>

          <p>
            Les chaussettes sont fabriquées avec du fil "Pole"65% laine / 35% alpaga, moelleux , doux et chaud.
            Les pompons sont en fil "Mille colori" 100% mérinos.
             <img src="../assets/furnitures/whool.png" class="whool" />
          </p>
          <router-link v-if="lang == 'fr'" to="/contact">Contactez-nous</router-link> pour commander des accessoires.
        
        </div>

        <h1 v-if="lang == 'en'">Furnitures</h1>

        <div class="description" v-if="lang=='en'">
          <img src="../assets/furnitures/sox0.png" alt="" class="main-sox"/>
          <p>
            Pour protéger vos têtes de club  dans de bonnes conditions et qualité, Amélie de Chassey a choisi de revenir aux valeurs classiques et d’antan. Utiliser de la laine de qualité  dans des mains bienveillantes et expérimentées de grandes tricoteuses (de tous âges et horizons…). Quelques-unes taillées sur le volet, réaliseront les "chaussettes" dont vous rêvez, couleurs, pompoms, filets, chiffres, points... Rien n’a de secret pour elles .
          </p>
          <p>
            En 10 jours votre série de trois couvre-bois ou autres pour un montant de 100 euros  vous sera envoyée ou 50 euros pour un seul à votre image (frais de port offert).
          </p>

          <div class="sox-gallery">
              <img src="../assets/furnitures/sox1.jpg" />
              <img src="../assets/furnitures/sox2.jpg" />
              <img src="../assets/furnitures/sox3.jpg" />
              <img src="../assets/furnitures/sox4.png" />
              <img src="../assets/furnitures/sox5.png" />
          </div>
          
          <p>
            Les chaussettes sont fabriquées avec du fil "Pole"65% laine / 35% alpaga, moelleux , doux et chaud.
            Les pompons sont en fil "Mille colori" 100% mérinos.
             <img src="../assets/furnitures/whool.png" class="whool" />
          </p>
          <router-link v-if="lang == 'fr'" to="/contact">Contactez-nous</router-link> pour commander des accessoires.
        
        </div>
    </div>

</template>

<script>
  import FlickityBox from './FlickityBox';

  export default {

    components: {
      FlickityBox,
    },
    props: ['lang'],
    data() {
      return {
      };
    },
  };
</script>
<style lang="scss">
    .furnitures-page {
      .description {
        
      }

      .main-sox {margin:auto; display:block;}
      .sox-gallery {
        text-align: center; vertical-align: middle;
        img {margin:0.5rem; vertical-align: top;}
      }
      .whool {margin-left:auto;padding:0.5rem;}
    }
</style>


// WEBPACK FOOTER //
// src/components/FurnituresPage.vue